import { useState } from "react";
import * as download from "../download";
import { filesService } from "../../services/files.service";
import * as constants from "../../constants/fixture.constants";
import { FileType } from "./useFileUpload";
import { toast } from "react-toastify";
import { useProgressQueue } from "../../store/progressQueue/useProgressQueue";

export type Trims = FileType & {
    metadata: {
        clip_from: number;
        filename: string;
    };
};

export interface UseTrims {
    loading: boolean;
    error: any;
    setTrims: (clipName:string, clips: { fileId: string, startTime: number, endTime: number, name: string, audioTrackId?: number, startMatchTime: string}[]) => void;
}

const useTrims = (): UseTrims => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const { addItem, removeItem } = useProgressQueue();
    let transcodingInterval: ReturnType<typeof setTimeout>;

    const setTrims = async (clipName: string,clips: { fileId: string, startTime: number, endTime: number, name: string, audioTrackId?: number, startMatchTime: string}[]) => {
        if (clips.length === 0 || clips[0].endTime - clips[0].startTime === 0) return;

        const trimId = constants.TRIM_ID.replace("{id}", clipName.toString());

        setLoading(true);
        addItem({
            id: trimId,
            name: constants.CREATING_CLIP_NAME.replace("{name}", clipName),
            active: true
        });
        setError(false);



        const transformedClips = clips.map(clip => ({
            fileId: Number(clip.fileId),
            time: clip.startMatchTime,
            aftermath: clip.endTime - clip.startTime,
            name: clip.name,
            audioTrackId: clip.audioTrackId,
            buildup: 0.0,
        }));

        try {
            /* Create clip */
            const response = await filesService.createMultiClip(clipName, transformedClips);
            /* Download clip once ready */
            transcodingInterval = setInterval(async () => {
                try {
                    const file = await filesService.getFile(response.id.toString());
                    if (file.status === "ERROR") {
                        clearInterval(transcodingInterval);
                        toast.error(constants.TRIM_ERROR);
                        setLoading(false);
                        removeItem(trimId);
                    }
                    if (file.status === "AVAILABLE") {
                        clearInterval(transcodingInterval);
                        const { location: Url } = await filesService.getFileSignedURL(file.id.toString());
                        download.downloadUrl(Url, clipName);
                        setLoading(false);
                        removeItem(trimId);
                    }
                } catch (intervalError) {
                    console.error("Interval fetch error:", intervalError);
                    clearInterval(transcodingInterval);
                    toast.error(constants.TRIM_ERROR);
                    setLoading(false);
                    removeItem(trimId);
                }
            }, 3000);
        } catch (error: any) {
            setError(error);
            toast.error(constants.TRIM_ERROR);
            setLoading(false);
            removeItem(trimId);

        }
    };

    return { loading, error, setTrims };
};

export default useTrims;